import React from 'react'
import ContactContainer from '../components/containers/ContactContainer'


function ContactSection({setIsNavigating}) {

  return (
    <section
      className="
        fixed
        bottom-0
        left-0
        w-full
        h-screen
        z-0
      "
    >
        <ContactContainer setIsNavigating={setIsNavigating}/>
    </section>
  )
}

export default ContactSection